import { showProgramSummary as showAscendQuestSummary } from '../../products/quest/summary/ProgramSummary';
import { showProgramSummary as showAscendArchivesSummary } from '../../products/archives/summary/ProgramSummary';
import { showProgramSummary as showAscendUSAASummary } from '../../products/usaa/summary/ProgramSummary';
import {
  isAscendArchivesProduct,
  isAscendQuestProduct,
  isAscendUSAAProduct,
} from '../../products/utils';
import { DatePicker } from '@/app/core/components/DatePicker';
import { Button, HStack, Input, VStack } from '@chakra-ui/react';
import {
  AscendArchivesProgram,
  AscendUSAAProgram,
  ProgramDataType,
  SSARProgram,
} from '@ssar-app/domain';
const { RangePicker } = DatePicker;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let searchInput: any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDateFilterProps = (): any => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterDropdown: (props: any) => (
    <VStack p={2}>
      <RangePicker
        value={props.selectedKeys}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(dates: any, _dateStrings) =>
          props.setSelectedKeys(dates ? dates : [])
        }
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <HStack>
        <Button
          variant='solid'
          colorScheme='blue'
          onClick={() => props.confirm()}
          size='sm'
          w='24'
        >
          Search
        </Button>
        <Button
          colorScheme='gray'
          onClick={() => {
            props.clearFilters();
            props.confirm();
          }}
          variant='outline'
          size='sm'
          w='24'
        >
          Reset
        </Button>
      </HStack>
    </VStack>
  ),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTextFilterProps = (title: string): any => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterDropdown: (props: any) => (
    <VStack p={2}>
      <Input
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref={(node: any) => {
          searchInput = node;
        }}
        placeholder={`Search ${title}`}
        value={props.selectedKeys[0]}
        onChange={(e) =>
          props.setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        size='sm'
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            props.confirm();
          }
        }}
        spellCheck={false}
      />
      <HStack>
        <Button
          variant='solid'
          colorScheme='blue'
          size='sm'
          w='24'
          onClick={() => props.confirm()}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            props.clearFilters();
            props.confirm();
          }}
          variant='outline'
          colorScheme='gray'
          size='sm'
          w='24'
        >
          Reset
        </Button>
      </HStack>
    </VStack>
  ),
  onFilterDropdownVisibleChange: (visible: boolean) => {
    if (visible) {
      setTimeout(() => searchInput.select());
    }
  },
});

export const showProgramSummaryInfo = (
  model: ProgramDataType,
  programId: string,
  version: string,
  showAccept: boolean,
  buildPath: (...paths: string[]) => string,
  draftId?: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history?: any,
  setIsProcessing?: (processing: boolean) => void,
) => {
  if (isAscendArchivesProduct()) {
    showAscendArchivesSummary(
      model as AscendArchivesProgram,
      programId,
      version,
      showAccept,
      buildPath,
      draftId,
      history,
      setIsProcessing,
    );
  } else if (isAscendQuestProduct()) {
    showAscendQuestSummary(
      model as SSARProgram,
      programId,
      version,
      showAccept,
      buildPath,
      draftId,
      history,
      setIsProcessing,
    );
  } else if (isAscendUSAAProduct()) {
    showAscendUSAASummary(
      model as AscendUSAAProgram,
      programId,
      version,
      showAccept,
      buildPath,
      draftId,
      history,
      setIsProcessing,
    );
  }
};
